import { galleryData } from "~/db/data"

export const useRestaurantDetailStore = defineStore('restaurantDetailStore', () => {
    const restaurantData: Ref<any> = ref(null)
    const restaurantSlidesData: Ref<any> = ref([])

    const $setRestaurantData = (data: any) => {
        restaurantData.value = data
        $setRestaurantSlidesData(data.images_thumb)
    }

    // Setting for areas
    const $setRestaurantSlidesData = (data: any[]) => {
        if(data && data.length > 0) {
            const groupedData: any[] = data.map((u: any) => {
                return {
                    ...u,
                    name: u.name,
                    imageUrl: u.imageUrl
                }
            });
            restaurantSlidesData.value = groupedData
        }
        else {
            restaurantSlidesData.value = null;
        }
    }

    return {
        restaurantData,
        restaurantSlidesData,
        $setRestaurantData,
        $setRestaurantSlidesData
    }
  })